module.exports = __webpack_public_path__ + "img/Support-skill-622.34a89050.png";